import { FC } from "react"
import React,{useEffect, useState, useMemo } from "react";
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { KTSVG } from "../../../smallnation/helpers"
import services from "../../modules/services/services"
import {  useLocation, useHistory } from "react-router-dom";


import moment from "moment"
import UsNumberValidate from "../../modules/utility/usNumberValidate"
import { ErrorMessage } from "@hookform/error-message";
import { set, useForm } from "react-hook-form";
import $ from 'jquery';
//import { useNavigate } from 'react-router-dom';
//import { TablesWidget10, TablesWidget5,TablesWidget1, TablesWidget2,TablesWidget3,TablesWidget4,TablesWidget6,TablesWidget7,TablesWidget8,TablesWidget9,TablesWidget11,TablesWidget12,TablesWidget13  } from "../../../smallnation/partials/widgets"
//import { ProfileDirectoryInc } from "../../../smallnation/partials/widgets/tables/profileDirectoryInc"


const CreateUser: FC = () => {
      const intl = useIntl()

      const red="red";
      const siteId = '2';
      let history = useHistory();
      const [schoolIds, setSchoolInData] = useState([]);

      const {
        register,
        formState: { errors },
        handleSubmit
      } = useForm({
        criteriaMode: "all",mode: "onBlur" 
      });
      const getSchoolistData = () => {
        //alert("14");
      const requestObject={
          "siteId":2,
          "pageNumber":1,
          "pageSize":150           
       }
      
       var accessTokenIn=sessionStorage.getItem("adminAccToken");
       const requestOptions = {
         method: 'POST',
         headers: { 'Content-Type': 'application/json',
                   'Authorization': "Bearer "+accessTokenIn 
                   //'Authorization': accessTokenIn 
                 },
         body: JSON.stringify(requestObject)
       };
      
       services.getSchoolnDatapag(requestOptions).then((res) => 
       {
          console.log("############36");
         console.log(JSON.stringify(res))
          if(res){
              
                 var contAr = res.content;
                 //setProfileList(res.content);
                 if(res){
                  setSchoolInData(res);
                 }                
                 
      
            }  
        //navigate('/thankyou');
      
       });
      
      
      }
      const submitValue = () => {
          var utype = $('#user_type').val();
          var email_regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
          var password_regex = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;

          var validateEditorTxt = 1;
          if($('#first_name').val() == ""){
            $("#firstnameValidMsg").show();  
            $(window).scrollTop($('#firstnameValidMsg').position().top);
            validateEditorTxt = 0;     
          }else{
            $("#firstnameValidMsg").hide();  
          }

          if($('#last_name').val() == ""){
            $("#lastnameValidMsg").show();  
            $(window).scrollTop($('#lastnameValidMsg').position().top);
            validateEditorTxt = 0;     
          }else{
            $("#lastnameValidMsg").hide();  
          }

          var email:any = $('#email_id').val();
          if(email == ""){
            $("#emailReqMsg").show();  
            $(window).scrollTop($('#emailReqMsg').position().top);
            validateEditorTxt = 0;     
          }else{
            $("#emailReqMsg").hide();  
          }
          
          if(email != "" && email_regex.test(email)==false){
            $("#emailValidMsg").show();  
            $(window).scrollTop($('#emailValidMsg').position().top);
            validateEditorTxt = 0;     
          }else{
            $("#emailValidMsg").hide();  
          }

          var password:any = $('#password').val();
          if(password == ""){
            $("#passwordReqMsg").show();  
            $(window).scrollTop($('#passwordReqMsg').position().top);
            validateEditorTxt = 0;     
          }else{
            $("#passwordReqMsg").hide();  
          }
          
          if(password != "" && password_regex.test(password)==false){
            $("#passwordValidMsg").show();  
            $(window).scrollTop($('#passwordValidMsg').position().top);
            validateEditorTxt = 0;     
          }else{
            $("#passwordValidMsg").hide();  
          }

          if(validateEditorTxt == 0){
            return false;
           }

         
          if(utype == "schooladmin")
          {
            const requestObjectSchoolAdmin={
              "siteId": 2,              
              "firstName": $('#first_name').val(),
              "lastName" : $('#last_name').val(),
              "email" : $('#email_id').val(),
              "phone" : $('#phone_number').val(),
              "userType" : "schoolAdmin",
              "schoolId" : $('#select_school').val(),
              "password" : $('#password').val(),
            }

            var accessTokenIn=sessionStorage.getItem("adminAccToken");
            const requestOptions = {
              method: 'POST',
              headers: { 'Content-Type': 'application/json',
                        'Authorization': "Bearer "+accessTokenIn 
                        //'Authorization': accessTokenIn 
                      },
              body: JSON.stringify(requestObjectSchoolAdmin)
            };

            services.createSchoolAdmin(requestOptions).then((res) => 
            {      
              if (res.code == '200') {  
                $("#addusersuccessMessage").fadeTo(2000, 500).slideUp(500, function () {
                  $("#addusersuccessMessage").slideUp(500);
                });
                setTimeout(() => {
                  history.push('/userslist');
                }, 1000);
              }
              else{
                $("#adduserfailMessage").fadeTo(2000, 500).slideUp(500, function () {
                  $("#adduserfailMessage").slideUp(500);
                });
                setTimeout(() => {
                  
                }, 1000);
              }       
            });

          }else if(utype == "schoolsuper"){

            const requestObjectSchoolAdmin={
              "siteId": 2,              
              "firstName": $('#first_name').val(),
              "lastName" : $('#last_name').val(),
              "email" : $('#email_id').val(),
              "phone" : $('#phone_number').val(),
              "userType" : "schoolSuperAdmin",             
              "password" : $('#password').val(),
            }

            var accessTokenIn=sessionStorage.getItem("adminAccToken");
            const requestOptions = {
              method: 'POST',
              headers: { 'Content-Type': 'application/json',
                        'Authorization': "Bearer "+accessTokenIn 
                        //'Authorization': accessTokenIn 
                      },
              body: JSON.stringify(requestObjectSchoolAdmin)
            };

            services.createSchoolSuperAdmin(requestOptions).then((res) => 
            {             
              if (res.code == '200') {  
                $("#addusersuccessMessage").fadeTo(2000, 500).slideUp(500, function () {
                  $("#addusersuccessMessage").slideUp(500);
                });
                setTimeout(() => {
                  history.push('/userslist');
                }, 1000);
              }
              else{
                $("#adduserfailMessage").html(res.message);
                $("#adduserfailMessage").fadeTo(2000, 500).slideUp(500, function () {
                  
                  $("#adduserfailMessage").slideUp(500);
                });
                setTimeout(() => {
                  
                }, 1000);
              }   
            });

          }
        
       // console.log(requestObject);
        return false;
        
      }
     const set_schooldistrict = () => {
         var usertype= $('#user_type').val();
        if(usertype == 'schooladmin'){
            $('#schooldistrict').show();   
        }
        else{
            $('#schooldistrict').hide();
            $('#select_school').val('');
        }
     }
      
      useEffect(() => 
      {       
        getSchoolistData(); 
       // $("#phone_number").usPhoneFormat();
       ($('#phone_number') as any).usPhoneFormat();
        $('#schooldistrict').hide();
        $('#firstnameValidMsg').hide();
        $('#lastnameValidMsg').hide();
        $('#emailValidMsg').hide();
        $('#passwordValidMsg').hide();
        $('#emailReqMsg').hide();
        $('#passwordReqMsg').hide();
        $('#addusersuccessMessage').hide();
        $('#adduserfailMessage').hide();
        console.log('user');
      },[]);
      type Props = {
        className: string
      }
      return (
        <>
          <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'Create User'})}</PageTitle>
          <form   onSubmit={handleSubmit(submitValue)}>     
             <div className="container">
               <div className="row">
               <div className="col-lg-6">
                              <div className="mb-10">
                                  <div className="d-flex flex-column ">
                                  <label className="required form-label">First Name </label>
                                  
                                </div>
                                <input id="first_name" name="first_name" type="text" className="form-control" placeholder="" />
                       <div id="firstnameValidMsg" style={{color:red}} className="error">First name is required.</div>
                            </div>
                        </div>
                        
                        <div className="col-lg-6">
                              <div className="mb-10">
                                  <div className="d-flex flex-column ">
                                  <label className="required form-label">Last Name </label>
                                 
                                </div>
                                <input type="text" id="last_name" name="last_name" className="form-control" placeholder=""  />
                         <div id="lastnameValidMsg" style={{color:red}} className="error">Last name is required.</div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                              <div className="mb-10">
                                  <div className="d-flex flex-column ">
                                    <label className="required form-label">Email</label>
                                     <small className="mb-3">Must be valid for notification</small>
                                </div>
                                <input type="text" id="email_id" name="email_id" className="form-control" placeholder=""  />
                       <div id="emailValidMsg" style={{color:red}} className="error">Invalid email address.</div>
                       <div id="emailReqMsg" style={{color:red}} className="error">Email Address is required.</div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                 <div className="mb-10">
                 <div className="d-flex flex-column ">
                 <label className=" form-label">Phone</label>
                                  <small className="mb-3">xxx-xxx-xxxx</small>
                 </div>
                 <input type="text" id="phone_number" name="phone_number" className="form-control" placeholder="" />
						
              </div>
                 </div>

                 <div className="col-lg-6">
                 <div className="mb-10">
                 <div className="d-flex flex-column ">
                 <label htmlFor="exampleFormControlInput1" className=" form-label">User Type</label>
                  
                 </div>
                    <select className="form-select" id="user_type" name="user_type" aria-label="Select example" onChange={set_schooldistrict}>
                    {/* <option selected value="siteadmin" >Sitewide Admin</option>              */}
                    <option value="schooladmin">School Admin</option>
                    <option value="schoolsuper" selected>School Super Admin</option>
                     </select>
              </div>
                 </div>
                 
                 <div className="col-lg-6">
                 <div className="mb-10"  id="schooldistrict">
                 <div className="d-flex flex-column ">
                 <label htmlFor="exampleFormControlInput1" className=" form-label">School District</label>
                 
                 </div>
                 <select className="form-select" id="select_school" name="select_school" aria-label="Select example">
                    <option selected value="" >Select School</option>             
                    {
                                  schoolIds.map((data, index) => (
                                  <option value={data.schoolId}>{data.name}</option>
                                  ))
                                }
                     </select>
              </div>
                 </div>

                 
                 <div className="col-lg-6">
                 <div className="mb-10">
                 <div className="d-flex flex-column ">
                 <label htmlFor="exampleFormControlInput1" className="required form-label">Password</label>
                 <small className="mb-3">Minimum of 8 characters long, and a combination of lowercase & uppercase letters, numbers, and special characters.</small>
                 <div className="row mt-8">

                 <input type="password" id="password" name="password" className="form-control" placeholder=""  />

<div id="passwordValidMsg" style={{color:red}} className="error">Password contain uppercase,lowercase and special character.</div>
<div id="passwordReqMsg" style={{color:red}} className="error">Password is required.</div>
                  <div className="divider"></div>
                 
                  <button type="submit" className="btn btn-primary mt-10" style={{maxWidth: "135px"}}> Create User </button>

                  <div id="addusersuccessMessage" className="alert alert-success" role="alert">Company Edited Successfully</div>
                    <div id="adduserfailMessage" className="alert alert-danger" role="alert">Please try again</div>
                 
                 </div>
                 </div>
               
              </div>
                 </div>

               </div>
             </div>
             </form>
        </>
      )
    }
export {CreateUser}